export const SCHOOL_TYPES = ['Co-educational', 'Girls'] as const

export const SCHOOL_LEVELS = ['Primary School', 'Middle School', 'High School', 'Higher Secondary School'] as const

export const MANAGEMENT_TYPES = [
  'Adhoc Aided', 'Central', 'Council Aided', 'Deficit', 'Deficit Mission',
  'Government', 'Local Body', 'Lumpsum Aided', 'Private', 'Samagra'
] as const

export const MEDIUM_TYPES = [
  'Bengali', 'Chakma', 'English', 'Hindi', 'Mizo', 'Nepali'
] as const

export const HABITATION_CLASSES = ['Rural', 'Urban'] as const

export const HABITATION_CATEGORIES = ['City', 'Town', 'Village'] as const

export const SOCIAL_GROUPS = ['ST', 'SC', 'OBC', 'General'] as const

export const RELIGIONS = ['Hindu', 'Islam', 'Christian', 'Sikh', 'Buddhist', 'Jain'] as const

export const GENDERS = ['Male', 'Female', 'Others'] as const

export const BLOCK_OFFICES = [
  'DEO Aizawl', 'DEO Champhai', 'DEO Hnahthial', 'DEO Khawzawl', 'DEO Kolasib',
  'DEO Lawngtlai', 'DEO Lunglei', 'DEO Mamit', 'DEO Saitual', 'DEO Serchhip',
  'DEO Siaha', 'Education Office(CADC)', 'Education Office (LADC)', 'Education Office (MADC)',
  'SDEO Aizawl East', 'SDEO Aizawl South', 'SDEO Aizawl West', 'SDEO Champhai',
  'SDEO Darlawn', 'SDEO Hnahthial', 'SDEO Kawnpui', 'SDEO Kawrthah', 'SDEO Khawzawl',
  'SDEO Kolasib', 'SDEO Lunglei North', 'SDEO Lunglei South', 'SDEO Lungsen', 'SDEO Mamit',
  'SDEO North Vanlaiphai', 'SDEO Ngopa', 'SDEO Saitual', 'SDEO Serchhip', 'SDEO Thenzawl', 'SDEO West Phaileng'
] as const

export const SUBJECTS = [
  'Maths', 'Mizo', 'English', 'Social Science', 'Science', 'Hindi', 'W.E'
] as const

export const CLASSES = [
  'Class 1', 'Class 2', 'Class 3', 'Class 4', 'Class 5',
  'Class 6', 'Class 7', 'Class 8', 'Class 9', 'Class 10',
  'Class 11', 'Class 12'
] as const
